export default __webpack_public_path__ + "static/media/devil-short.4a311897.svg";